import {api} from "./routes";
import {generatePath} from "react-router";
import {makeRequest, Methods} from "./request";

// METHODS
// ---- GET : Fetch one single LevelA problem based on its identifier
export function get_single_problem(identifier, token) {
    const url = api.domain + generatePath(api.routes.singleProblem, { identifier })
    return makeRequest(url, Methods.GET, null, token)
}

export function get_exerciser_problem(identifier) {
    const url = api.domain + generatePath(api.routes.exerciserProblem, { identifier })
    return makeRequest(url, Methods.GET, null)
}